import { useLayoutEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { registerProtectedRoute } from '@/lib/api/core';
import { useSessionHeartbeat } from '@/hooks/useSessionHeartbeat';
import { useAuthStore } from '@/store/authStore';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  // Session heartbeat for visit tracking (only when authenticated)
  useSessionHeartbeat();

  // Marks this page as requiring a session, so an unrecoverable 401 sends the
  // visitor to /login here and ONLY here - a public page instead signs out in
  // place. A layout effect because it must be registered before any child's
  // passive effect can start a request.
  useLayoutEffect(() => registerProtectedRoute(), []);

  if (!isAuthenticated) {
    // Capture the current path and search params to redirect back after login
    const currentPath = location.pathname + location.search;
    const returnUrl = encodeURIComponent(currentPath);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  return <>{children}</>;
}
